import { render } from "./BlockDocument.vue?vue&type=template&id=3995356c&scoped=true"
import script from "./BlockDocument.vue?vue&type=script&lang=js"
export * from "./BlockDocument.vue?vue&type=script&lang=js"

import "./BlockDocument.vue?vue&type=style&index=0&id=3995356c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3995356c"]])

export default __exports__